export default {"src":"/_next/static/media/salesforce.b7d5c63f.svg","height":25,"width":31,"blurWidth":0,"blurHeight":0};